import React from 'react';
import { Modal } from 'react-bootstrap';
import StudioPlayListForm from './StudioPlayListForm';

const PlaylistEditModal = ({ setModalShow, showModal, handleClose, editPlaylistID, nshowModal, setnModalShow }) => {
	return (
		<>
			<Modal show={showModal} onHide={handleClose} className="add__modal">
				<Modal.Header closeButton>
					{editPlaylistID ? <Modal.Title>Edit Playlist</Modal.Title> : <Modal.Title>Add New Playlist</Modal.Title>}
				</Modal.Header>
				<Modal.Body>
					<StudioPlayListForm
						setShow={setModalShow}
						editPlaylistID={editPlaylistID}
						nshowModal={nshowModal}
						setnModalShow={setnModalShow}
					/>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default PlaylistEditModal;
